exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".topBarWarning .ieWarning{background-color:#004163;padding:10px 20%;text-align:center;color:#c8ecff}.topBarWarning .ieWarning a{color:#68caff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/layout/top_bar_warning.scss
// module id = 1311
// module chunks = 0